import { render, staticRenderFns } from "./ImagePostBody.vue?vue&type=template&id=3749f752&scoped=true&"
import script from "./ImagePostBody.vue?vue&type=script&lang=js&"
export * from "./ImagePostBody.vue?vue&type=script&lang=js&"
import style0 from "./ImagePostBody.vue?vue&type=style&index=0&id=3749f752&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3749f752",
  null
  
)

export default component.exports